export function openAttachment() {
    return (
        window['footerPanel'] &&
        window['footerPanel'].openAttachment &&
        window['footerPanel'].openAttachment()
    );
}

export function openFilePreviewContextMenu(x, y) {
    return (
        window['footerPanel'] &&
        window['footerPanel'].openFilePreviewContextMenu &&
        window['footerPanel'].openFilePreviewContextMenu(x, y)
    );
}

export function checkFile(fileName, callback) {
    return (
        window['footerPanel'] &&
        window['footerPanel'].checkFile &&
        window['footerPanel'].checkFile(fileName, callback)
    );
}

export function togglePinActiveScreens(value) {
    window['footerPanel'] &&
        window['footerPanel'].toggleActiveScreensPinned &&
        window['footerPanel'].toggleActiveScreensPinned(value);
}
